import React from "react";
import { ArrowUpRight, ChartNoAxesCombined, Github, Utensils } from "lucide-react";
import { useT } from "../context/LanguageContext";

const APPS = [
  { key: "finance", name: "Verasist Finance", href: "https://finance.verasist.ai", icon: ChartNoAxesCombined },
  { key: "diet", name: "Verasist Diet", href: "https://diet.verasist.ai", icon: Utensils },
];

const AppsSection = () => {
  const t = useT();

  return (
    <section aria-labelledby="apps-title" className="py-16 lg:py-24 px-6" style={{ color: "var(--fg)" }}>
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl mb-10">
          <p className="text-xs font-semibold uppercase tracking-widest mb-4" style={{ color: "var(--brand-cyan)" }}>
            Verasist API & SDK
          </p>
          <h2 id="apps-title" className="font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl">
            {t("apps.title")}
          </h2>
          <p className="mt-5 text-base leading-relaxed opacity-90">{t("apps.description")}</p>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {APPS.map(({ key, name, href, icon: Icon }) => (
            <article key={key} className="rounded-3xl p-7 sm:p-9 flex flex-col items-start" style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}>
              <Icon size={32} aria-hidden="true" style={{ color: "var(--brand-cyan)" }} />
              <h3 className="mt-6 text-2xl font-semibold tracking-tight">{name}</h3>
              <p className="mt-3 mb-7 text-base leading-relaxed opacity-90">{t(`apps.${key}.description`)}</p>
              <div className="mt-auto flex flex-wrap items-center gap-5">
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-semibold transition-opacity hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4"
                  style={{ background: "var(--fg)", color: "var(--bg)" }}
                >
                  {t(`apps.${key}.cta`)}
                  <ArrowUpRight size={16} aria-hidden="true" />
                </a>
                <a
                  href={`https://github.com/electronicengine/verasist-${key}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${name} · ${t("apps.github")}`}
                  className="inline-flex items-center gap-2 rounded py-2 text-sm font-semibold underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4"
                >
                  <Github size={18} aria-hidden="true" />
                  {t("apps.github")}
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AppsSection;
